export default "__VITE_ASSET__0262dc05__"